module.exports = __webpack_public_path__ + "img/PL08937.2903991c.png";